import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
const monthNames = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const toYearMonth = date => dayjs(date).format('YYYYMM');
const toDisplayYearMonth = date => dayjs(date).format('MMM-YYYY');

const toShortDate = yyyyMmDd => {
  dayjs.extend(customParseFormat);
  return dayjs(`${yyyyMmDd}`, 'YYYYMMDD').format('DD-MMM'); };

const toFullDate = yyyyMmDd => {
  if (yyyyMmDd === null || yyyyMmDd === undefined) {return  '';}
  dayjs.extend(customParseFormat);
  return dayjs(`${yyyyMmDd}`, 'YYYYMMDD').format('DD-MMM-YYYY'); };

const toMonth = yyyyMmDd => {
  dayjs.extend(customParseFormat);
  return dayjs(`${yyyyMmDd}`, 'YYYYMMDD').format('MMM');
};

const toMonthYear = yyyyMm => {
  let year = `${yyyyMm}`.substring(2, 4);
  let month = `${yyyyMm}`.substring(4);
  return monthNames[parseInt(month)] + '-' +  year;
};

export {toYearMonth, toShortDate, toFullDate, toMonth, toDisplayYearMonth, toMonthYear};
